import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts";
import { PageLoader } from "../components";

/**
 * AuthGuard - Protects routes that require authentication.
 *
 * If the user is not authenticated, they are redirected to the login page.
 * The original URL is saved so they can be redirected back after login.
 *
 * @example
 * // In router config:
 * {
 *   element: <AuthGuard />,
 *   children: [
 *     { path: "/profiles", element: <ProfilesPage /> }
 *   ]
 * }
 */
export function AuthGuard() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (isLoading) {
    return <PageLoader />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    // Save the attempted URL for redirecting after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated, render child routes
  return <Outlet />;
}

export default AuthGuard;
